import { render, staticRenderFns } from "./BuySubscriptionModal.vue?vue&type=template&id=6b40db1e"
import script from "./BuySubscriptionModal.vue?vue&type=script&lang=js"
export * from "./BuySubscriptionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports